'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SocialLinkedIn = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("rect", {
                width: "16",
                height: "16",
                rx: "8",
                fill: "#0065C9"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.18189 6.18427C7.17923 6.23027 7.17656 6.25827 7.17656 6.28693C7.17656 7.98554 7.17723 9.68481 7.17456 11.3834C7.17456 11.4747 7.20389 11.5001 7.29189 11.4994C7.74854 11.4961 8.20586 11.4981 8.66251 11.4974C8.80983 11.4974 8.8105 11.4974 8.8105 11.3481C8.8105 10.4468 8.80783 9.54548 8.8125 8.64351C8.81383 8.36819 8.89716 8.1142 9.07249 7.89621C9.39315 7.49689 10.0858 7.36556 10.4758 7.70088C10.7264 7.91687 10.8398 8.20419 10.8438 8.52085C10.8558 9.46148 10.8498 10.4028 10.8511 11.3434C10.8518 11.4974 10.8518 11.4974 11.0091 11.4981C11.4551 11.4981 11.9011 11.4981 12.347 11.4974C12.4977 11.4974 12.4984 11.4974 12.4984 11.3487C12.499 10.3788 12.503 9.40882 12.4957 8.43885C12.4944 8.19686 12.4764 7.95087 12.4344 7.71221C12.3417 7.18823 12.0964 6.74558 11.6551 6.43159C11.2571 6.14894 10.8104 6.03761 10.3218 6.07427C9.80713 6.11294 9.35115 6.2896 8.96183 6.62825C8.87583 6.70358 8.80517 6.79625 8.7205 6.88824C8.7205 6.68492 8.7165 6.49093 8.7225 6.29693C8.72517 6.20627 8.69184 6.18094 8.60384 6.18227C8.27985 6.18694 7.95587 6.18427 7.63254 6.18427C7.48588 6.18427 7.33855 6.18427 7.18189 6.18427Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.28111 8.8327C6.28111 7.99207 6.27978 7.15143 6.28246 6.31079C6.28311 6.21613 6.26044 6.18013 6.15645 6.18143C5.68913 6.18747 5.22115 6.1868 4.75316 6.18213C4.6565 6.1808 4.63184 6.2128 4.63184 6.30479C4.6345 7.9934 4.6345 9.68134 4.63184 11.3699C4.63184 11.4693 4.66583 11.4999 4.76316 11.4993C5.21648 11.4953 5.67046 11.4979 6.12378 11.4979C6.28044 11.4973 6.28111 11.4973 6.28111 11.3433C6.28111 10.5066 6.28111 9.66934 6.28111 8.8327Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.4146 4.47269C6.4146 3.93338 5.98261 3.49406 5.4573 3.50006C4.92865 3.50539 4.50133 3.93071 4.5 4.45136C4.49933 4.98934 4.93932 5.42199 5.47863 5.41332C6.00528 5.40532 6.4146 4.99401 6.4146 4.47269Z",
                fill: "white"
            })
        ]
    });
};

module.exports = SocialLinkedIn;
